// @core/api/endpoints/calendar/reschedule_entity.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  CalendarLifecycleResponse,
  RescheduleEntityRequest,
} from '../../../types/calendar';

const BASE_PATH = '/calendar';

/**
 * Reschedule entity
 * Moves any calendar-aware entity to a new time slot. Re-validates availability and notifies relevant parties.
 */
export async function RescheduleEntity(
  target_type: string,
  target_id: string,
  data: RescheduleEntityRequest,
  options?: RequestOptions
): Promise<CalendarLifecycleResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/calendar/:target_type/:target_id/reschedule`;
  requestPath = requestPath.replace(':target_type', encodeURIComponent(target_type));
  requestPath = requestPath.replace(':target_id', encodeURIComponent(target_id));
  const requestOptions = options;
  return client.post<CalendarLifecycleResponse>(requestPath, data, requestOptions);
}
